export const createPaths = (...args) => "/" + args.join('/')